(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/quotes-small-card/render"] = factory(require("FEGORender"), require("FEGOWebapi"));
	else
		root["/fego/component/quotes-small-card/render"] = factory(root["FEGORender"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 